module.exports = __webpack_public_path__ + "static/media/envelop-back.b0a90b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelop-back.png
// module id = 7581
// module chunks = 0